import { authClient, API } from "../index";

export const getPedidos = async () => {
  return authClient().get(`${API}/pedido`);
};

export const updatePedido = async (id, data) => {
  return authClient().put(`${API}/pedido/${id}`, data);
};

export const deletePedido = async (id) => {
  return authClient().delete(`${API}/pedido/${id}`);
};

export const getPedidoById = async (id) => {
  return authClient().get(`${API}/pedido/${id}`);
};

// Count pending pedidos (unread)
export const countPendingPedidos = () => {
  return authClient().get(`${API}/pedido/count-pending`);
};

export const markPedidosAsRead = () => {
  return authClient().patch(`${API}/pedido/mark-all-read`);
};

